export default __webpack_public_path__ + "static/media/092-camping-tent.90f0027b.svg";